import { render, staticRenderFns } from "./AnimatedTitle.vue?vue&type=template&id=0bbc6190"
import script from "./AnimatedTitle.vue?vue&type=script&lang=js"
export * from "./AnimatedTitle.vue?vue&type=script&lang=js"
import style0 from "./AnimatedTitle.vue?vue&type=style&index=0&id=0bbc6190&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports